import {Component, input, InputSignal} from '@angular/core';
import {ThirdPartyComponent} from '../third-party.component';

@Component({
  selector: 'app-third-party-wrapper',
  standalone: true,
  imports: [
    ThirdPartyComponent
  ],
  template: `
    <div class="page-top d-flex justify-content-center">
      <app-third-party [vendorName]="vendorName()"
                       [name]="name()">
      </app-third-party>
    </div>`
})
export class ThirdPartyWrapperComponent {
  readonly vendorName: InputSignal<string> = input.required();
  readonly name: InputSignal<string> = input.required();
}
